import loadable from '@loadable/component';

import { CmsApiTileGridBlockData } from 'modules/cms/api/types/blocks/CmsApiTileGridBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';
import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const CmsTileGridBlockMapping: CmsBlockMapping<CmsApiTileGridBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: hydrateOnDemand(
      loadable(() => import('./CmsTileGridBlock'), {
        resolveComponent: (module) => module.CmsTileGridBlock,
      }),
    ),
  };
